import { render, staticRenderFns } from "./OrderReport.vue?vue&type=template&id=10e34f68&scoped=true"
import script from "./OrderReport.vue?vue&type=script&lang=ts"
export * from "./OrderReport.vue?vue&type=script&lang=ts"
import style0 from "./OrderReport.vue?vue&type=style&index=0&id=10e34f68&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e34f68",
  null
  
)

export default component.exports